import { ApiProperty } from "@nestjs/swagger";

export class CodeListValidationReq{
    @ApiProperty()
    codeListMainId : number;

    @ApiProperty()
    isActive : boolean;

    @ApiProperty()
    issuedBy : string;

    @ApiProperty()
    verifiedBy : string;

    @ApiProperty()
    totalCartons : number;


    
}